(() => {
  'use strict';
  const mm = value => value * 72 / 25.4;
  const num = value => Number(value.toFixed(3));
  const literal = value => '(' + [...String(value)].map(char => {
    let code = char.charCodeAt(0);
    if (char === '€') code = 128;
    if ('–—'.includes(char)) code = 45;
    if (code > 255) code = 63;
    const ascii = String.fromCharCode(code);
    return code < 32 || code > 126 ? '\\' + code.toString(8).padStart(3, '0') : /[()\\]/.test(ascii) ? '\\' + ascii : ascii;
  }).join('') + ')';
  function create(title) {
    const pages = [], images=[], imageIds=new Map();
    function page() {
      const commands = [];
      const sizingNotice=['Schnellauslegung - keine Garantie für Maße, Flächen, Mengen und Materialbedarf.','Alle Angaben sind vor Bestellung und Ausführung durch den ausführenden Fachbetrieb vor Ort zu prüfen.','Zu viel bestellte Produkte werden nicht zurückgenommen.'];
      sizingNotice.forEach((text,i)=>commands.push(`BT /F1 7 Tf ${num(mm(12))} ${num(mm(297-(277+i*3)))} Td ${literal(text)} Tj ET`));
      pages.push(commands);
      return {
        text(value, x, y, size = 10, bold = false) {
          commands.push(`BT /${bold ? 'F2' : 'F1'} ${size} Tf ${num(mm(x))} ${num(mm(297 - y))} Td ${literal(value)} Tj ET`);
        },
        rect(x, y, width, height, black = true) {
          commands.push(`${black ? 0 : 1} g ${num(mm(x))} ${num(mm(297 - y - height))} ${num(mm(width))} ${num(mm(height))} re f 0 g`);
        },
        line(x, y, width) {
          commands.push(`0.5 w ${num(mm(x))} ${num(mm(297 - y))} m ${num(mm(x + width))} ${num(mm(297 - y))} l S`);
        },
        image(bitmap,x,y,width,height){
          if(!bitmap||!/^([a-f0-9]{2})+$/i.test(bitmap.hex)||!Number.isInteger(bitmap.width)||!Number.isInteger(bitmap.height)||bitmap.width<1||bitmap.height<1)throw Error('Bildformat ist ungültig.');
          let id=imageIds.get(bitmap.hex);if(id===undefined){id=images.length;imageIds.set(bitmap.hex,id);images.push(bitmap);}
          commands.push(`q ${num(mm(width))} 0 0 ${num(mm(height))} ${num(mm(x))} ${num(mm(297-y-height))} cm /Im${id} Do Q`);
        },
        qr(matrix, x, y, width) {
          const step = width / (matrix.length + 8);
          this.rect(x, y, width, width, false);
          for (let row = 0; row < matrix.length; row++) for (let col = 0; col < matrix.length; col++) if (matrix[row][col]) this.rect(x + (col + 4) * step, y + (row + 4) * step, step, step);
        }
      };
    }
    function bytes() {
      const objects = ['', '<< /Type /Catalog /Pages 2 0 R >>', '', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>'];
      const resources=images.map((image,index)=>{const id=objects.length,stream=image.hex+'>';objects.push(`<< /Type /XObject /Subtype /Image /Width ${image.width} /Height ${image.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter [/ASCIIHexDecode /DCTDecode] /Length ${stream.length} >>\nstream\n${stream}\nendstream`);return `/Im${index} ${id} 0 R`;}).join(' ');
      const kids = [];
      for (const commands of pages) {
        const id = objects.length, stream = commands.join('\n');
        kids.push(`${id} 0 R`);
        objects.push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${num(mm(210))} ${num(mm(297))}] /Resources << /Font << /F1 3 0 R /F2 4 0 R >> /XObject << ${resources} >> >> /Contents ${id + 1} 0 R >>`, `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`);
      }
      objects[2] = `<< /Type /Pages /Count ${pages.length} /Kids [${kids.join(' ')}] >>`;
      let output = '%PDF-1.4\n', offsets = [0];
      for (let id = 1; id < objects.length; id++) { offsets.push(output.length); output += `${id} 0 obj\n${objects[id]}\nendobj\n`; }
      const xref = output.length;
      output += `xref\n0 ${objects.length}\n0000000000 65535 f \n` + offsets.slice(1).map(offset => String(offset).padStart(10, '0') + ' 00000 n \n').join('') + `trailer\n<< /Size ${objects.length} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF\n`;
      return new TextEncoder().encode(output);
    }
    return {page, bytes, download(filename) {
      const url = URL.createObjectURL(new Blob([bytes()], {type: 'application/pdf'})), link = document.createElement('a');
      link.href = url; link.download = filename; link.textContent = title; document.body.append(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    }};
  }
  function wrap(value, max) {
    const lines = [];
    for (const word of String(value || '').split(/\s+/)) {
      let rest = word;
      while (rest.length > max) { if (lines.at(-1)) lines.push(''); lines.push(rest.slice(0, max)); rest = rest.slice(max); }
      if (!lines.length || (lines.at(-1).length + rest.length + 1 > max)) lines.push(rest);
      else lines[lines.length - 1] += (lines.at(-1) ? ' ' : '') + rest;
    }
    return lines.filter(Boolean);
  }
  window.ShkPDF = {create, wrap};
})();



